import * as yup from 'yup';

export const formSchema = yup.object({
  productName: yup.string().nullable().required(),
  werks: yup.string().nullable().required(),
  enterpriseId: yup.number().nullable().required(),
  startDate: yup
    .date()
    .required('Start Date is required')
    .min(new Date(), 'Start Date should not be in past'),
  endDate: yup
    .date()
    .required('End Date is required')
    .min(new Date(), 'End Date should not be in past'),
  slabs: yup
    .array(
      yup
        .object({
          value: yup
            .number()
            .nullable()
            .required('value is required')
            .typeError('A number is required'),
          unit: yup
            .string()
            .nullable()
            .required('unit is required'),
          quantityStart: yup
            .number()
            .nullable()
            .required('start quantity is required')
            .typeError('A number is required'),
        })
        .required()
    )
    .required('Please add at least one slab for discount')
    .min(1, 'Please add at least one slab for discount'),
});

export type TFormDataBulkDiscount = yup.InferType<
  typeof formSchema
>;
